import { Component, OnInit, Input } from '@angular/core';
import { UtilServico } from 'src/app/servicos/util.servico';
import { UtilDadosLogado } from 'src/app/servicos/util.logado';
import { DatePipe } from '@angular/common';
import { CertificadoService } from 'src/app/servicos/certificado.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'cdk-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  @Input() sidenav: any;
  @Input() sidebar: any;
  @Input() drawer: any;
  @Input() matDrawerShow: any;

  searchOpen: boolean = false;

  toolbarMensagens: any;
  Ambiente: string = "";
  Certificado: string = "";
  mostrarVencimento: boolean = false;

  constructor(
    private utilServico: UtilServico, 
    private utilDadosLogado: UtilDadosLogado, 
    private datepipe: DatePipe,
    private certificadoService: CertificadoService
  ) {}

  ngOnInit() {
    // const dataCerticado = localStorage.getItem('vencimento_certificado');
    // this.Certificado       = dataCerticado
    // this.mostrarVencimento = this.utilDadosLogado.DadosAcesso().cetificado;
    this.certificadoService.certificado$.subscribe( (dataCertificado: any)=>{
      if (dataCertificado) {
        this.Certificado = dataCertificado;
      } else {
        const storedDate = localStorage.getItem('vencimento_certificado');
        if (storedDate) {
          this.Certificado = storedDate;
        }
      }
    })

    this.certificadoService.mostrarCertificado$.subscribe( (mostrarCertificado: any)=>{
      if (mostrarCertificado) {
        this.mostrarVencimento = mostrarCertificado;
      } else {
        const storedDate = localStorage.getItem('vencimento_certificado');
        if (storedDate) {
          this.mostrarVencimento = true;
        }
      }
    }) 
  
  }

  CarregarNotificacoes(): void {
    this.utilServico.Get(`Notificacao/${this.utilDadosLogado.DadosAcesso().usuario_id}`).subscribe(
      data => {
        this.toolbarMensagens = {
          notificacoes: data
        };
      },
      error => {}
    );
  }

  formataData(rawDate) { 
    let formattedDate = "";
    const date = new Date(rawDate); 
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear();
    formattedDate = `${day}/${month}/${year}`;
    return formattedDate; 
  }

}
